import { render, staticRenderFns } from "./coach-feedback-modal.vue?vue&type=template&id=00ed1736&scoped=true"
import script from "./coach-feedback-modal.vue?vue&type=script&lang=js"
export * from "./coach-feedback-modal.vue?vue&type=script&lang=js"
import style0 from "./coach-feedback-modal.vue?vue&type=style&index=0&id=00ed1736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ed1736",
  null
  
)

export default component.exports